import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { API_URL } from "./config";
import Swal from "sweetalert2";
import { BarLoader } from "react-spinners";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const credObj = { email, password };

        try {
            const response = await fetch(`${API_URL}/authors/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(credObj)
            });

            const data = await response.json();

            if (response.ok && data.success) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('author', JSON.stringify(data.author));
                localStorage.setItem('authorId', data.author.id);
                setIsLoading(false);
                // Redirect based on role
                if (data.author.is_admin === 1) {
                    navigate('/admin');
                } else {
                    navigate('/dashboard');
                }
            } else {
                Swal.fire({
                    text: data.error || "Invalid credentials!",
                    icon: "error"
                });
                setIsLoading(false);
            }
        } catch (err) {
            Swal.fire({
                text: "Login failed, check your network connection!",
                icon: "error"
            });
            setIsLoading(false);
        }
    };

    return (
        <div style={{ backgroundColor: '#e0f2fe', height: '100vh', margin: 0 }}>
            <div className="container" style={{ height: '100%' }}>
                <div className="row justify-content-center" style={{ height: '100%', alignItems: 'center' }}>
                    <div className="col-xl-10 col-lg-12 col-md-9">
                        <div className="card o-hidden border-0 shadow-lg my-5" style={{ top: '-13px', width: '110%', marginLeft: '-50px' }}>
                            <div className="card-body p-0" style={{ height: '500px' }}>
                                <div className="row">
                                    <div className="col-lg-6 d-none d-lg-block bg-login-image">
                                        <img src="../assets/tantak-logo.PNG" height="500px" width="550px" alt="Background" />
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="p-5">
                                            <div className="row text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0 }}>
                                                <div className="col-lg-8" style={{ marginLeft: '-50px' }}>
                                                    <div>
                                                        <img src="../assets/tantak-logo.PNG" height="50px" width="120px" alt="Logo" />
                                                    </div>
                                                    <h1 className="h4 text-gray-900 mb-4" style={{ margin: 0 }}>Author Sign In</h1>
                                                </div>
                                            </div>

                                            <form className="user" onSubmit={handleLogin}>
                                                <div className="form-group">
                                                    <input
                                                        type="email"
                                                        className="form-control form-control-user custom-input"
                                                        id="exampleInputEmail"
                                                        aria-describedby="emailHelp"
                                                        placeholder="Enter Email Address..."
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required
                                                        style={{ height: '50px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        className="form-control form-control-user custom-input"
                                                        id="exampleInputPassword"
                                                        placeholder="Password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox small custom-btn" style={{ float: 'left' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customCheck"
                                                        />
                                                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                                                    </div>
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-dark btn-user btn-block"
                                                    type="submit"
                                                    style={{ backgroundColor: '#1e3a8a', borderColor: '#1e3a8a', width: '100%' }}
                                                >
                                                    Login
                                                </button>
                                            </form>
                                            <hr />
                                        </div>
                                        <br /><br /><br /><br /><br />
                                    </div>
                                    {isLoading && (
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '-55px' }}>
                                            <BarLoader size={40} width={'100%'} color="#1e3a8a" loading />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;